import { Megaphone, Rocket, Workflow } from 'lucide-react';
import { PERM } from './permissions';

const campaignMeta = {
  icon: Megaphone,
  color: 'text-orange-600',
  bg: 'bg-orange-50 dark:bg-orange-900/30',
};
const workflowMeta = {
  icon: Workflow,
  color: 'text-purple-600',
  bg: 'bg-purple-50 dark:bg-purple-900/30',
};

export const LAUNCH_CAMPAIGN_WORKFLOW = 'launch_campaign_workflow';

export const AUTOMATION_ACTION_META = {
  create_campaign: { ...campaignMeta, label: 'Create Campaign Template', successMessage: 'Campaign template created as draft' },
  update_campaign: { ...campaignMeta, label: 'Update Campaign Template', successMessage: 'Campaign template updated' },
  // Legacy direct-activation cards; Caleb now activates campaigns through workflows.
  activate_campaign: { ...campaignMeta, label: 'Enroll in Campaign', successMessage: 'Accounts enrolled in campaign' },
  set_campaign_status: { ...campaignMeta, label: 'Change Campaign Status', successMessage: 'Campaign status updated' },
  create_workflow: { ...workflowMeta, label: 'Create Workflow', successMessage: 'Workflow created as draft' },
  update_workflow: { ...workflowMeta, label: 'Update Workflow', successMessage: 'Workflow updated' },
  set_workflow_status: { ...workflowMeta, label: 'Change Workflow Status', successMessage: 'Workflow status updated' },
  execute_workflow: { ...workflowMeta, label: 'Run Workflow', successMessage: 'Workflow run completed' },
  [LAUNCH_CAMPAIGN_WORKFLOW]: {
    icon: Rocket,
    color: 'text-indigo-600',
    bg: 'bg-indigo-50 dark:bg-indigo-900/30',
    label: 'Launch Campaign via Workflow',
    successMessage: 'Workflow active and campaign launched',
  },
};

export const AUTOMATION_ACTION_PERMISSIONS = Object.fromEntries(
  Object.keys(AUTOMATION_ACTION_META).map((name) => {
    if (name === LAUNCH_CAMPAIGN_WORKFLOW) {
      return [name, [PERM.CAMPAIGNS_MANAGE, PERM.WORKFLOWS_MANAGE]];
    }
    return [name, [name.includes('campaign') ? PERM.CAMPAIGNS_MANAGE : PERM.WORKFLOWS_MANAGE]];
  }),
);

/** Actions whose listed permissions are all required (the backend enforces the same). */
export const REQUIRES_ALL_PERMISSIONS = new Set([LAUNCH_CAMPAIGN_WORKFLOW]);
